import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const InsuranceShieldCheckIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 41 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    filter: "url(#filter0_dd_6081_32090)"
  }, __jsx("path", {
    d: "M35.1642 14.6661C35.1642 16.9822 35.3034 19.3085 35.1379 21.6144C34.5997 29.1612 28.3566 36.425 20.7942 38.4204C20.3528 38.531 19.889 38.5262 19.4503 38.4067C11.6556 36.181 5.85052 29.2976 5.12051 21.4369C5.05014 20.6764 5.01145 19.9105 5.00968 19.1465C4.99677 15.6786 4.99677 12.2107 5.00968 8.74286C5.00968 7.43818 5.77839 6.68091 7.10125 6.62291C9.68362 6.51039 11.6503 5.37623 12.799 3.13006C13.4112 1.93619 14.245 1.47229 15.603 1.50127C18.7694 1.56609 21.92 1.53709 25.0793 1.51322C26.1435 1.51322 26.8613 1.9106 27.3275 2.84354C28.5367 5.26305 30.5304 6.52516 33.3086 6.62964C34.4713 6.67244 35.2735 7.46707 35.2822 8.60123C35.2963 10.6223 35.2822 12.6417 35.2822 14.6626L35.1642 14.6661ZM31.4578 15.6519H31.3401C31.3401 14.035 31.3276 12.4114 31.3488 10.8031C31.3488 10.4177 31.245 10.2728 30.8335 10.172C29.5267 9.87854 28.2927 9.33786 27.2024 8.58059C26.112 7.82354 25.1866 6.86491 24.4796 5.75985C24.4034 5.62387 24.2874 5.51265 24.1463 5.44031C24.0051 5.36819 23.8449 5.33799 23.6861 5.35407C21.3394 5.36775 18.991 5.37101 16.6497 5.35407C16.4808 5.33734 16.3105 5.36928 16.1603 5.44618C16.0101 5.52286 15.8866 5.64103 15.8053 5.78549C14.3991 7.97952 12.1559 9.5464 9.56402 10.1449C9.08376 10.2609 8.9448 10.4297 8.94826 10.8969C8.97118 13.6412 8.93602 16.3835 8.97294 19.126C8.96021 20.212 9.0509 21.2966 9.24386 22.3665C10.4559 28.2454 13.9776 32.2824 19.7335 34.4755C19.9922 34.5681 20.2757 34.5724 20.5373 34.4875C26.3231 32.2976 29.9239 28.2591 31.0374 22.3358C31.4402 20.1425 31.3312 17.8759 31.4578 15.6519Z",
    fill: color
  }), __jsx("path", {
    d: "M35.0323 14.4199C35.0326 13.826 35.0339 13.2328 35.0353 12.6398C35.0384 11.2937 35.0416 9.94922 35.0322 8.60297M35.0323 14.4199L35.0322 8.60297M35.0323 14.4199L34.9142 14.4233V14.6661C34.9142 15.4025 34.928 16.1351 34.9418 16.8651C34.9717 18.4514 35.0013 20.025 34.8885 21.5965L34.8885 21.5966C34.3585 29.0299 28.1966 36.2078 20.732 38.1783C20.333 38.278 19.9139 38.2736 19.5174 38.1659C11.8194 35.9671 6.0896 29.168 5.36944 21.4139C5.29972 20.6603 5.26143 19.9019 5.25968 19.1459L5.25968 19.1455C5.24677 15.6783 5.24677 12.211 5.25968 8.74379V8.74286C5.25968 8.1403 5.43606 7.69405 5.73669 7.39163C6.03861 7.08793 6.49528 6.89972 7.1122 6.87267C9.7735 6.75669 11.8272 5.57942 13.0216 3.2439L12.799 3.13006M35.0323 14.4199L35.1642 14.6661C35.1642 15.3922 35.1779 16.1193 35.1916 16.8465C35.2215 18.4388 35.2515 20.0314 35.1379 21.6144C34.5997 29.1612 28.3566 36.425 20.7942 38.4204C20.3528 38.531 19.889 38.5262 19.4503 38.4067C11.6556 36.181 5.85052 29.2976 5.12051 21.4369C5.05014 20.6764 5.01145 19.9105 5.00968 19.1465C4.99677 15.6786 4.99677 12.2107 5.00968 8.74286C5.00968 7.43818 5.77839 6.68091 7.10125 6.62291C9.68362 6.51039 11.6503 5.37623 12.799 3.13006M35.0322 8.60297C35.0283 8.09655 34.8484 7.67901 34.5517 7.38326C34.2542 7.08686 33.8252 6.89883 33.2994 6.87948L33.2992 6.87947C31.8739 6.82586 30.6363 6.47451 29.5959 5.81596C28.5552 5.15719 27.7258 4.19971 27.1038 2.9553L27.3275 2.84354M35.0322 8.60297L27.3275 2.84354M27.3275 2.84354L27.1038 2.95529C26.888 2.52338 26.6226 2.23141 26.3018 2.04455C25.9797 1.85688 25.5812 1.76333 25.0803 1.76322M27.3275 2.84354L25.0803 1.76322M12.799 3.13006C13.4112 1.93619 14.245 1.47229 15.603 1.50127C18.6035 1.5627 21.5898 1.53987 24.5828 1.517C24.7483 1.51573 24.9138 1.51447 25.0793 1.51322M12.799 3.13006L13.0215 3.24413C13.3123 2.67692 13.6443 2.30487 14.046 2.0738C14.4488 1.84206 14.9474 1.73734 15.5977 1.75122L15.5979 1.75122C18.602 1.81272 21.5916 1.78987 24.5837 1.767C24.7492 1.76573 24.9147 1.76447 25.0803 1.76322M25.0793 1.51322V1.76322C25.0796 1.76322 25.08 1.76322 25.0803 1.76322M25.0793 1.51322L25.0812 1.76321C25.0809 1.76321 25.0806 1.76322 25.0803 1.76322M25.0793 1.51322L25.0803 1.76322M31.7225 15.4019L31.7074 15.6661C31.6685 16.3496 31.6522 17.0456 31.6357 17.7471C31.5995 19.2903 31.5626 20.8599 31.2833 22.381L31.2831 22.382C30.1521 28.398 26.4862 32.5032 20.6258 34.7213L20.6146 34.7255L20.6145 34.7253C20.3002 34.8273 19.96 34.8221 19.6493 34.7109L19.6445 34.7092L19.6445 34.7092C13.8123 32.4869 10.229 28.3831 8.99901 22.4169L8.99776 22.4108L8.99783 22.4108C8.80225 21.3264 8.71022 20.227 8.72292 19.1263C8.70254 17.6099 8.70417 16.0864 8.70581 14.5648C8.70712 13.3401 8.70844 12.1166 8.69827 10.899L8.69827 10.8988C8.69641 10.6486 8.73012 10.4153 8.88139 10.2307C9.02994 10.0495 9.25379 9.96261 9.50532 9.90186L9.50777 9.90127L9.50777 9.90128C12.0352 9.31767 14.2208 7.79105 15.5913 5.65621C15.697 5.47127 15.8555 5.32107 16.0466 5.22353M31.7225 15.4019L16.0466 5.22353M31.7225 15.4019H31.59C31.5898 15.0467 31.589 14.6915 31.5883 14.3365C31.5858 13.1562 31.5834 11.9776 31.5988 10.8064L31.5988 10.8064V10.8031C31.5988 10.5976 31.5737 10.3913 31.4409 10.2249C31.3095 10.0602 31.1108 9.98257 30.893 9.9292L30.893 9.92915L30.8883 9.9281C29.6127 9.64162 28.4086 9.11393 27.345 8.37526L27.345 8.37524C26.2833 7.63808 25.3823 6.70532 24.6938 5.63082C24.5931 5.45429 24.4422 5.31102 24.2603 5.21782L24.26 5.21768C24.0797 5.12556 23.876 5.08605 23.6735 5.10414C21.3349 5.11774 18.9949 5.12097 16.6623 5.10415C16.4501 5.08543 16.2363 5.12647 16.0466 5.22351L16.1603 5.44618L16.0464 5.22364C16.0464 5.22361 16.0465 5.22357 16.0466 5.22353M31.7225 15.4019L16.0466 5.22353",
    stroke: "#05AFF2",
    strokeWidth: "0.5"
  })), __jsx("g", {
    filter: "url(#filter1_dd_6081_32090)"
  }, __jsx("path", {
    d: "M18.233 20.9641C18.4774 20.7373 18.6534 20.582 18.8205 20.4184C20.6067 18.6901 22.3909 16.9618 24.1735 15.2336C25.0847 14.357 26.2845 14.2921 27.1007 15.063C27.917 15.834 27.8888 17.0518 26.9651 17.9505C24.5975 20.2553 22.2245 22.5531 19.8461 24.8443C18.84 25.8181 17.7351 25.8129 16.729 24.8443C15.5785 23.7355 14.4316 22.6224 13.2881 21.5048C12.4244 20.6519 12.3699 19.4906 13.1439 18.7129C13.9513 17.9027 15.1581 17.9266 16.064 18.7981C16.7923 19.4974 17.4941 20.224 18.233 20.9641Z",
    fill: color
  }), __jsx("path", {
    d: "M18.0561 21.1407L18.2264 21.3113L18.4031 21.1473C18.4855 21.0709 18.5614 21.0014 18.6325 20.9363C18.7668 20.8134 18.8839 20.7063 18.9949 20.5976C20.7809 18.8695 22.5648 17.1415 24.3471 15.4134C25.18 14.6125 26.227 14.5816 26.9291 15.2448C27.6257 15.9028 27.6292 16.9555 26.7908 17.7713L26.7907 17.7713C24.4234 20.0758 22.0507 22.3734 19.6727 24.6642L19.6722 24.6646C19.2017 25.12 18.7333 25.3232 18.2878 25.3227C17.8422 25.3221 17.3733 25.1176 16.9024 24.6643C15.7525 23.5561 14.6062 22.4435 13.4633 21.3264C12.6828 20.5553 12.6598 19.5537 13.3211 18.8893C14.0203 18.1877 15.0704 18.1891 15.8907 18.9783L15.8909 18.9784C16.3923 19.4599 16.8798 19.9531 17.3783 20.4573C17.6013 20.6829 17.8265 20.9107 18.0561 21.1407Z",
    stroke: "#05AFF2",
    strokeWidth: "0.5"
  })), __jsx("defs", null, __jsx("filter", {
    id: "filter0_dd_6081_32090",
    x: "0",
    y: "0.5",
    width: "40.2891",
    height: "47",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, __jsx("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), __jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), __jsx("feMorphology", {
    radius: "1",
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6081_32090"
  }), __jsx("feOffset", {
    dy: "4"
  }), __jsx("feGaussianBlur", {
    stdDeviation: "3"
  }), __jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), __jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), __jsx("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6081_32090"
  }), __jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), __jsx("feMorphology", {
    radius: "2",
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_6081_32090"
  }), __jsx("feOffset", {
    dy: "2"
  }), __jsx("feGaussianBlur", {
    stdDeviation: "2"
  }), __jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), __jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), __jsx("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6081_32090",
    result: "effect2_dropShadow_6081_32090"
  }), __jsx("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6081_32090",
    result: "shape"
  })), __jsx("filter", {
    id: "filter1_dd_6081_32090",
    x: "7.59961",
    y: "13.5273",
    width: "25.0879",
    height: "21.0469",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, __jsx("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), __jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), __jsx("feMorphology", {
    radius: "1",
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6081_32090"
  }), __jsx("feOffset", {
    dy: "4"
  }), __jsx("feGaussianBlur", {
    stdDeviation: "3"
  }), __jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), __jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), __jsx("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6081_32090"
  }), __jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), __jsx("feMorphology", {
    radius: "2",
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_6081_32090"
  }), __jsx("feOffset", {
    dy: "2"
  }), __jsx("feGaussianBlur", {
    stdDeviation: "2"
  }), __jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), __jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), __jsx("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6081_32090",
    result: "effect2_dropShadow_6081_32090"
  }), __jsx("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6081_32090",
    result: "shape"
  }))));
};
export default InsuranceShieldCheckIcon;